import React, { FC } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FormInputText } from '../../inputs/FormInputText';
import { CustomMUIButton } from '../../commons/buttons/CustomMUIButton';
import { TextButton } from '../../commons/buttons/TextButton';
import { ApiError } from '../../../models/ApiError';
import { ButtonClassNames, InputRegexPattern, InputTextFormat, LoginRouteNames } from '../../../models/Common';
import { authorizationApi } from '../../../services/apiServices/user/authorization';

interface LoginWithSmsProps {
  handleBack: () => void;
  handleLink: (link: LoginRouteNames) => void;
}

export const RequestCodeSms: FC<LoginWithSmsProps> = ({ handleBack, handleLink }) => {
  const { t } = useTranslation();
  const methods = useForm();
  const { handleSubmit, setError } = methods;
  const [requestCodeSms, { isLoading }] = authorizationApi.useRequestCodeSmsMutation();

  const submitRequestCodeSMS = async (accountPhone: { accountPhone: string }) => {
    try {
      await requestCodeSms(accountPhone.accountPhone)
        .unwrap()
        .then(() => {
          localStorage.setItem('accountPhone', accountPhone.accountPhone);
          handleLink(LoginRouteNames.EnterCodeSmsForm);
        });
    } catch (err) {
      const error = err as ApiError;
      setError('accountPhone', {
        type: 'server',
        message: error?.data?.error?.message,
      });
    }
  };

  const handleAlreadyHaveCodeSms = () => {
    handleLink(LoginRouteNames.EnterCodeSmsForm);
  };

  return (
    <div>
      <div className="login-send-sms-container">
        <p className="login-send-sms-container__title login-page__title">{t('auth.authWithSms')}</p>
        <p className="login-send-sms-container__text">{t('auth.anAuthorizationCodeWillBeSent')}</p>
        <FormProvider {...methods}>
          <form className="login-send-sms-container__form" onSubmit={handleSubmit(submitRequestCodeSMS)}>
            <FormInputText
              name="accountPhone"
              className="primary"
              label={t('auth.accountPhone')}
              isRequired
              minLength={4}
              pattern={InputRegexPattern.OnlyNumbers}
              format={InputTextFormat.ContractNumberOrPhone}
              helperText={t('auth.enterAccountPhoneInFormat')}
            />
            <div className="login-send-sms-container__form__btn-group">
              <CustomMUIButton
                label={t('common.back')}
                handleClick={handleBack}
                className={ButtonClassNames.SecondaryOutlined}
                isBold
              />
              <CustomMUIButton
                label={t('common.sendSms')}
                type="submit"
                className={ButtonClassNames.PrimaryFulfilled}
                isBold
                isLoading={isLoading}
              />
            </div>
            <div className="login-send-sms-container__form__btn-text">
              <TextButton
                label={t('auth.iAlreadyHaveSmsCode')}
                handleClick={handleAlreadyHaveCodeSms}
                className="primary"
                isArrow={false}
                isDisabled={isLoading}
              />
            </div>
          </form>
        </FormProvider>
      </div>
    </div>
  );
};
